import { downloadAttachment } from "../../../../api/api";
import { useQuery } from "react-query";
import CustomSkeleton from "../../../carConfiguration/components/skeleton/skeleton";

const BudgetPreview = ({
	flowId,
	attachmentKey,
	mimeType,
	download,
	title,
}) => {
	const {
		data: file,
		isLoading,
		isError,
	} = useQuery(
		["file", flowId, attachmentKey, mimeType],
		async () => downloadAttachment(flowId, attachmentKey, mimeType),
		{
			enabled: !!flowId && !!attachmentKey && !!mimeType,
		},
	);

	if (isError) {
		return (
			<div className=" flex items-center justify-center">
				<span className="p-4">Vi hadde problemer med å hente dokumentet</span>
			</div>
		);
	}
	return (
		<div className="w-[70svw]">
			{isLoading && (
				<CustomSkeleton
					skeletons={[{ width: "100%", height: "70vh", count: 1 }]}
					border={false}
				/>
			)}
			{!!title && <div className="text-lg font-semibold p-4">{title}</div>}
			{file && (
				<>
					<div className="flex sm:hidden h-[400px] items-center justify-center text-center">
						<span>
							Ved mindre skjermstørrelser har nettleseren problemer med å vise
							dokumentet korrekt. Vennligst{" "}
							<a
								href={file}
								download
								className="text-blue-500 hover:underline cursor-pointer"
							>
								last ned dokumentet istedenfor.
							</a>
						</span>
					</div>

					<iframe
						className="hidden sm:block h-[70vh] w-full"
						title="file"
						src={`${file}#toolbar=0&zoom=page-width`}
					/>
				</>
			)}

			{download && file && (
				<a
					href={file}
					download
					className="fixed bottom-10 right-10 px-4 py-2 bg-blue-500 text-white rounded-md shadow-lg hover:bg-blue-600"
				>
					Last ned dokument
				</a>
			)}
		</div>
	);
};

export default BudgetPreview;
